<template>
  <v-card>
    <v-card-title>
      Images
    </v-card-title>
    <v-divider/>
    <v-card-text>


      <storage-upload
        v-if="getStoragePath()"
        :storage-path="getStoragePath()"
      />

      <storage-file-list
        v-if="getStoragePath()"
        :storage-path="getStoragePath()"
      />


    </v-card-text>
  </v-card>
</template>
<script>
import StorageUpload from "../Common/StorageUpload"
import StorageFileList from "../Common/StorageFileList"
import { mapGetters } from 'vuex'
import { generateUUID4 } from "../../services/util.service"

export default {
  components: { StorageFileList, StorageUpload },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([
      'getSessionTenant'
    ])
  },
  data() {
    return {
      uuid: null,
      model: {}
    }
  },
  watch: {
    product() {
      this.original = { ...this.product }
    }
  },
  methods: {
    getStoragePath() {
      const path = this.product.id
        ? `tenants/${this.getSessionTenant}/products/${this.product.id}/`
        : `tenants/${this.getSessionTenant}/tmp/products/${this.uuid}/`

      this.$emit('new-storage-path', path)

      return path
    }
  },
  created() {
    this.uuid = generateUUID4()
  },
  mounted() {
    this.original = { ...this.product }
    this.model = { ...this.original }
  }
}
</script>
